// ExtendedSimpleSelect mode
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import CommonSelect from './CommonSelect.jsx';
import _ from 'lodash';

const ExtendedSimpleSelect = _.extend({}, MapboxDraw.modes.simple_select);

// Useful for debugging
// ExtendedSimpleSelect.onSetup = function(opts) {
//     console.log("Opts: ", opts);
//     let state = MapboxDraw.modes.simple_select.onSetup.call(this, opts);
//     console.log("State: ", state);
//     return state;
// };

ExtendedSimpleSelect.startOnActiveFeature = function (state, e) {
    MapboxDraw.modes.simple_select.startOnActiveFeature.call(this, state, e);
    CommonSelect.startOnActiveFeature.call(this, state, e);
};

ExtendedSimpleSelect.dragMove = function (state, e) {
    if (!state.extrudingTargetId) {
        return MapboxDraw.modes.simple_select.dragMove.call(this, state, e);
    }
    CommonSelect.dragMove.call(this, state, e);
};

ExtendedSimpleSelect.toDisplayFeatures = function (state, geojson, display) {
    MapboxDraw.modes.simple_select.toDisplayFeatures.call(this, state, geojson, display);
    CommonSelect.toDisplayFeatures.call(this, state, geojson, display);
};

export default ExtendedSimpleSelect;
